import { createStore } from 'vuex';
import users from './users';
import plans from './plans';
import tags from './tags';
import auth from './auth';
import crm from './crm';
import furniture from './furniture';
import svg from './svg';
import substances from './substances';
import branding from './substances/branding';
import materials from './materials';
import apertures from './apertures';
import moldings from './moldings';
import locale from './locale';
import planBatch from './planBatch';
import xmas from './xmas';
import guards from './guards';

export default createStore({
  state: {
    isResponsive: false,
  },
  mutations: {
    setResponsive(state, isResponsive) {
      state.isResponsive = isResponsive;
    },
  },
  actions: {
  },
  modules: {
    users,
    plans,
    tags,
    auth,
    crm,
    furniture,
    svg,
    substances,
    branding,
    locale,
    materials,
    apertures,
    moldings,
    planBatch,
    xmas,
    guards,
  },
});
